import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgModule } from '@angular/core';
import { AccountPlanCommandHandlerResolver } from '../accounting/service/command/account-plan-command-handler-resolver.service';
import { CopyAccountPlanCommandHandler } from '../accounting/service/command/copy-account-plan-command-handler.service';
import { RentLossCommandHandlerResolver } from '../accounting/service/command/rent-loss-command-handler-resolver.service';
import { CommonModule } from '../common/common.module';
import { OverviewModule } from '../overview/overview.module';
import { CoreModule } from './../core/core.module';
import { AddContactBalanceFormComponent } from './component/add-contact-balance-form/add-contact-balance-form.component';
import { B2CSubscriptionsComponent } from './component/b2c-subscriptions/b2c-subscriptions.component';
import { BgMaxImportFormComponent } from './component/bg-max-import-form/bg-max-import-form.component';
import { BgPaymentManagerComponent } from './component/bg-payment-manager/bg-payment-manager.component';
import { AmortizationPlanDocumentFormComponent } from './component/amortization-plan-document-form/amortization-plan-document-form.component';
import { AmortizationPlanDocumentManagerComponent } from './component/amortization-plan-document-manager/amortization-plan-document-manager.component';
import { AmortizationPlanDetailsComponent } from './component/amortization-plan-details/amortization-plan-details.component';
import { AmortizationPlanManagerComponent } from './component/amortization-plan-manager/amortization-plan-manager.component';
import { AmortizationPlanPaymentNoticeManagerComponent } from './component/amortization-plan-payment-notice-manager/amortization-plan-payment-notice-manager.component';
import { CancelAmortizationPlanFormComponent } from './component/cancel-amortization-plan-form/cancel-amortization-plan-form.component';
import { CreateAmortizationPlanPaymentNoticePageComponent } from './component/create-amortization-plan-payment-notice-page/create-amortization-plan-payment-notice-page.component';
import { CreateAmortizationPlanPaymentNoticeSidebarComponent } from './component/create-amortization-plan-payment-notice-sidebar/create-amortization-plan-payment-notice-sidebar.component';
import { ESignAmortizationPlanDocumentComponent } from './component/esign-amortization-plan-document/esign-amortization-plan-document.component';
import { ChangeIncorrectPaymentPayerFormComponent } from './component/change-incorrect-payment-payer-form/change-incorrect-payment-payer-form.component';
import { ContactBalanceTransactionListComponent } from './component/contact-balance-transaction-list/contact-balance-transaction-list.component';
import { CreateAmortizationPlanSidebarComponent } from './component/create-amortization-plan-sidebar/create-amortization-plan-sidebar.component';
import { CreateInvoiceFormComponent } from './component/create-invoice-form/create-invoice-form.component';
import { CreditInvoiceFormComponent } from './component/credit-invoice-form/credit-invoice-form.component';
import { CreditInvoiceListComponent } from './component/credit-invoice-list/credit-invoice-list.component';
import { RegisterCustomerLossFormComponent } from './component/customer-loss-form/customer-loss-form.component';
import { DebtCollectionManagerComponent } from './component/debt-collection-manager/debt-collection-manager.component';
import { DebtCollectionFormComponent } from './component/debt-collection.form/debt-collection-form.component';
import { DeliverInvoiceReminderComponent } from './component/deliver-invoice-reminder/deliver-invoice-reminder.component';
import { DeliverInvoiceComponent } from './component/deliver-invoice/deliver-invoice.component';
import { DirectDebitComponent } from './component/direct-debit/direct-debit.component';
import { IncorrectPaymentFormComponent } from './component/incorrect-payment-form/incorrect-payment-form.component';
import { IncorrectPaymentListComponent } from './component/incorrect-payment-list/incorrect-payment-list.component';
import { InvoiceDeliveriesComponent } from './component/invoice-deliveries/invoice-deliveries.component';
import { InvoiceDeliveryConfigurationComponent } from './component/invoice-delivery-configuration/invoice-delivery-configuration';
import { InvoiceDeliveryComponent } from './component/invoice-delivery/invoice-delivery.component';
import { InvoiceFormComponent } from './component/invoice-form/invoice-form.component';
import { InvoiceListComponent } from './component/invoice-list/invoice-list.component';
import { InvoicePeriodComponent } from './component/invoice-period/invoice-period.component';
import { InvoiceReminderListComponent } from './component/invoice-reminder-list/invoice-reminder-list.component';
import { InvoiceStatusComponent } from './component/invoice-status/invoice-status.component';
import { LeaseAgreementInvoicesComponent } from './component/lease-agreement-invoices/lease-agreement-invoices.component';
import { MovePaymentFormComponent } from './component/move-payment-form/move-payment-form.component';
import { PayInvoiceFormComponent } from './component/pay-invoice-form/pay-invoice-form.component';
import { PreviewInvoicesComponent } from './component/preview-invoices/preview-invoices.component';
import { PrintOrderManagerComponent } from './component/print-order-manager/print-order-manager.component';
import { RegisterPaymentFormComponent } from './component/register-payment-form/register-payment-form.component';
import { RegisterPaymentNoticePaymentFormComponent } from './component/register-payment-notice-payment-form/register-payment-notice-payment-form.component';
import { RegulateFromBalanceFormComponent } from './component/regulate-from-balance-form/regulate-from-balance-form.component';
import { RentalObjectInvoicesComponent } from './component/rental-object-invoices/rental-object-invoices.component';
import { RepayPaymentFormComponent } from './component/repay-payment-form/repay-payment-form.component';
import { TenantInvoicesComponent } from './component/tenant-invoices/tenant-invoices.component';
import { VoidPaymentFormComponent } from './component/void-payment-form/void-payment-form.component';
import { AttestCommandHandler } from './service/command/attest-command-handler.service';
import { CreditInvoiceCommandHandler } from './service/command/credit-invoice-command-handler.service';
import { CreditInvoicesCommandHandler } from './service/command/credit-invoices-command-handler.service';
import { CustomerLossCommandHandler } from './service/command/customer-loss-command-handler.service';
import { DebtCollectionCommandHandler } from './service/command/debt-collection-command-handler.service';
import { DeleteInvoicesCommandHandler } from './service/command/delete-invoices-command-handler.service';
import { DirectDebitCommandHandlerResolver } from './service/command/direct-debit-command-handler-resolver.service';
import { DirectDebitExportCommandHandler } from './service/command/direct-debit-export-command-handler.service';
import { ContactBalanceTransactionExportCommandHandler } from './service/command/export-contact-balance-transaction-command-handler.service';
import { IncorrectPaymentExportCommandHandler } from './service/command/export-incorrect-payment-command-handler.service';
import { InvoiceReminderExportCommandHandler } from './service/command/export-invoice-reminder-command-handler.service';
import { InvoiceExportCommandHandler } from './service/command/export-invoices-command-handler.service';
import { InvoiceTransactionsExportCommandHandler } from './service/command/export-invoices-transactions-command-handler.service';
import { InvoicePdfCommandHandler } from './service/command/invoice-pdf-command-handler.service';
import { OpenInvoiceFromDirectDebitCommandHandler } from './service/command/open-invoice-from-directdebit-command-handler.service';
import { OpenInvoiceFromReminderCommandHandler } from './service/command/open-invoice-from-reminder-command-handler.service';
import { PaymentMethodCommandHandlerResolver } from './service/command/payment-method-command-handler-resolver.service';
import { PreviewInvoiceReminderCommandHandler } from './service/command/preview-invoice-reminder-command-handler.service';
import { RegisterPaymentCommandHandler } from './service/command/register-payment-command-handler.service';
import { RegulateFromBalanceCommandHandler } from './service/command/regulate-from-balance-command-handler.service';
import { ReminderInvoiceCommandHandler } from './service/command/reminder-invoice-command-handler.service';
import { SendCommandHandler } from './service/command/send-command-handler.service';
import { SetDefermentDateCommandHandler } from './service/command/set-deferment-date-command-handler.service';
import { B2CSubscriptionContactService } from './service/data/b2c-subscription-contact.service';
import { B2CSubscriptionService } from './service/data/b2c-subscription.service';
import { AmortizationPlanDocumentService } from './service/data/amortization-plan-document.service';
import { AmortizationPlanLogService } from './service/data/amortization-plan-log.service';
import { AmortizationPlanPaymentNoticeService } from './service/data/amortization-plan-payment-notice.service';
import { AmortizationPlanService } from './service/data/amortization-plan.service';
import { ContactBalanceTransactionService } from './service/data/contact-balance-transaction.service';
import { CreditInvoiceService } from './service/data/credit-invoice.service';
import { DebtCollectionService } from './service/data/debt-collection.service';
import { DirectDebitService } from './service/data/direct-debit.service';
import { IncorrectPaymentService } from './service/data/incorrect-payment.service';
import { InvoiceDeliveryConfigurationService } from './service/data/invoice-delivery-configuration.service';
import { InvoiceReminderService } from './service/data/invoice-reminder.service';
import { InvoiceTransactionService } from './service/data/invoice-transaction.service';
import { InvoiceService } from './service/data/invoice.service';
import { PayerService } from './service/data/payer.service';
import { PaymentMethodService } from './service/data/payment-method.service';
import { PaymentService } from './service/data/payment.service';
import { PrintOrderService } from './service/data/print-order.service';
import { DirectDebitLogService } from './service/data/direct-debit-log.service';
import { DirectDebitLogManagerComponent } from './component/direct-debit-log-manager/direct-debit-log-manager.component';
import { InvoiceLogService } from './service/data/invoice-log.service';
import { InvoicePdfWithRegulationsCommandHandler } from './service/command/invoice-pdf-with-regulations-command-handler.service';
import { UnhandledBankTransactionFormComponent } from './component/unhandled-bank-transaction-form/unhandled-bank-transaction-form.component';
import { BankTransactionImportService } from './service/data/bank-transaction-import.service';
import { UnhandledBankTransactionImportManagerComponent } from './component/unhandled-bank-transactions-manager/bank-transaction-import-manager.component';
import { ChangeBankTransactionImportStatusCommandHandler } from './service/command/change-bank-import-transaction-status-handler.service';
import { ChangeBankTransactionStatusFormComponent } from './component/change-bank-transaction-status/change-bank-transaction-status-form.component';
import { BankImportBookAsIncorrectPaymentCommandHandler } from './service/command/bank-import-book-as-incorrect-payment-handler.service';
import { InvoiceRowGroupFormComponent } from './component/invoice-row-group-form/invoice-row-group-form.component';
import { InvoiceRowGroupMultiSelectManagerComponent } from './component/invoice-row-group-manager/invoice-row-group-manager.component';
import { InvoiceRowGroupService } from './service/data/invoice-row-group.service';
import { InvoiceRowFormComponent } from './component/invoice-row-form/invoice-row-form.component';
import { InvoiceRowService } from './service/data/invoice-row-service';
import { InvoiceRowListComponent } from './component/invoice-row-list/invoice-row-list.component';
import { InvoiceAmountService } from './service/invoice-amount.service';
import { InvoiceExportWithInvoiceRowsCommandHandler } from './service/command/export-invoices-with-invoice-rows-command-handler.service';
import { InvoiceReminderFormComponent } from './component/invoice-reminder-form/invoice-reminder-form.component';
import { InvoiceListRentInvoicingOrderComponent } from './component/invoice-list-rent-invoicing-order/invoice-list-rent-invoicing-order';
import { VoidIncorrectPaymentsCommandHandler } from './service/command/void-incorrect-payments-command-handler.service';

@NgModule({
  imports: [CommonModule, CoreModule, OverviewModule, DragDropModule],
  declarations: [
    InvoiceStatusComponent,
    AmortizationPlanDocumentFormComponent,
    AmortizationPlanDocumentManagerComponent,
    AmortizationPlanDetailsComponent,
    AmortizationPlanManagerComponent,
    AmortizationPlanPaymentNoticeManagerComponent,
    CancelAmortizationPlanFormComponent,
    CreateAmortizationPlanPaymentNoticePageComponent,
    CreateAmortizationPlanPaymentNoticeSidebarComponent,
    ESignAmortizationPlanDocumentComponent,
    InvoiceDeliveryComponent,
    InvoiceRowFormComponent,
    InvoiceRowListComponent,
    CreateInvoiceFormComponent,
    DebtCollectionManagerComponent,
    DebtCollectionFormComponent,
    IncorrectPaymentListComponent,
    ContactBalanceTransactionListComponent,
    CreateAmortizationPlanSidebarComponent,
    InvoiceReminderListComponent,
    InvoiceListComponent,
    InvoicePeriodComponent,
    InvoiceDeliveryConfigurationComponent,
    InvoiceRowGroupFormComponent,
    InvoiceRowGroupMultiSelectManagerComponent,
    MovePaymentFormComponent,
    PreviewInvoicesComponent,
    TenantInvoicesComponent,
    LeaseAgreementInvoicesComponent,
    RentalObjectInvoicesComponent,
    InvoiceListRentInvoicingOrderComponent,
    InvoiceFormComponent,
    RegisterPaymentFormComponent,
    RegisterPaymentNoticePaymentFormComponent,
    RegulateFromBalanceFormComponent,
    DeliverInvoiceComponent,
    DeliverInvoiceReminderComponent,
    InvoiceDeliveriesComponent,
    BgMaxImportFormComponent,
    BgPaymentManagerComponent,
    DirectDebitComponent,
    DirectDebitLogManagerComponent,
    IncorrectPaymentFormComponent,
    PayInvoiceFormComponent,
    AddContactBalanceFormComponent,
    PrintOrderManagerComponent,
    VoidPaymentFormComponent,
    RepayPaymentFormComponent,
    ChangeIncorrectPaymentPayerFormComponent,
    CreditInvoiceFormComponent,
    CreditInvoiceListComponent,
    RegisterCustomerLossFormComponent,
    B2CSubscriptionsComponent,
    UnhandledBankTransactionFormComponent,
    UnhandledBankTransactionImportManagerComponent,
    ChangeBankTransactionStatusFormComponent,
    InvoiceReminderFormComponent,
  ],
  providers: [
    AccountPlanCommandHandlerResolver,
    AttestCommandHandler,
    BankImportBookAsIncorrectPaymentCommandHandler,
    ChangeBankTransactionImportStatusCommandHandler,
    CopyAccountPlanCommandHandler,
    CreditInvoiceCommandHandler,
    AmortizationPlanDocumentService,
    AmortizationPlanLogService,
    AmortizationPlanPaymentNoticeService,
    AmortizationPlanService,
    CustomerLossCommandHandler,
    CreditInvoiceService,
    CreditInvoicesCommandHandler,
    VoidIncorrectPaymentsCommandHandler,
    DebtCollectionCommandHandler,
    DebtCollectionService,
    DeleteInvoicesCommandHandler,
    IncorrectPaymentExportCommandHandler,
    ContactBalanceTransactionExportCommandHandler,
    InvoiceExportCommandHandler,
    InvoiceReminderExportCommandHandler,
    OpenInvoiceFromReminderCommandHandler,
    OpenInvoiceFromDirectDebitCommandHandler,
    PreviewInvoiceReminderCommandHandler,
    InvoiceTransactionsExportCommandHandler,
    DirectDebitCommandHandlerResolver,
    DirectDebitExportCommandHandler,
    DirectDebitService,
    DirectDebitLogService,
    InvoiceDeliveryConfigurationService,
    IncorrectPaymentService,
    ContactBalanceTransactionService,
    InvoiceReminderService,
    InvoicePdfCommandHandler,
    InvoicePdfWithRegulationsCommandHandler,
    InvoiceService,
    InvoiceRowService,
    InvoiceRowGroupService,
    InvoiceLogService,
    InvoiceTransactionService,
    PayerService,
    PaymentMethodService,
    PaymentService,
    PrintOrderService,
    RegisterPaymentCommandHandler,
    RegulateFromBalanceCommandHandler,
    ReminderInvoiceCommandHandler,
    SendCommandHandler,
    SetDefermentDateCommandHandler,
    PaymentMethodCommandHandlerResolver,
    RentLossCommandHandlerResolver,
    B2CSubscriptionService,
    B2CSubscriptionContactService,
    BankTransactionImportService,
    InvoiceAmountService,
    InvoiceExportWithInvoiceRowsCommandHandler,
    // TODO-B2C: command handler
  ],
  exports: [InvoiceDeliveryConfigurationComponent, InvoiceListRentInvoicingOrderComponent, PreviewInvoicesComponent],
})
export class InvoiceModule {}
